import httpClient from './httpClient';

const contratosEmpleadoService = {
  async obtenerPorEmpleado(empleadoId) {
    try {
      const response = await httpClient.get(`/contratos-empleado/empleado/${empleadoId}`);
      return {
        success: true,
        data: response.data.data || [],
        solapamientos: response.data.solapamientos || [],
        tiene_solapamientos: !!response.data.tiene_solapamientos,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener contratos del empleado',
        data: [],
        solapamientos: [],
        tiene_solapamientos: false,
      };
    }
  },

  async vistaPrevia(payload) {
    try {
      const response = await httpClient.post('/contratos-empleado/vista-previa', payload);
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al generar vista previa',
      };
    }
  },

  async asignar(payload) {
    try {
      const response = await httpClient.post('/contratos-empleado/asignar', payload);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'Contrato asignado exitosamente',
        advertencia_solapamiento: response.data.advertencia_solapamiento || null,
        contratos_solapados: response.data.contratos_solapados || [],
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al asignar contrato',
        errors: error.response?.data?.errors,
      };
    }
  },

  async obtenerContrato(id) {
    try {
      const response = await httpClient.get(`/contratos-empleado/${id}`);
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener contrato',
      };
    }
  },

  async obtenerResumenPorEmpresa(empresaId) {
    try {
      const response = await httpClient.get(`/contratos-empleado/empresa/${empresaId}/resumen`);
      return {
        success: true,
        data: response.data.data || {},
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener resumen de contratos',
        data: {},
      };
    }
  },

  async obtenerAlertasDashboard(empresaId) {
    try {
      const response = await httpClient.get(`/contratos-empleado/empresa/${empresaId}/alertas-dashboard`);
      return {
        success: true,
        data: response.data.data || {
          por_vencer: [],
          pendientes: [],
          vencidos: [],
          totales: { por_vencer: 0, pendientes: 0, vencidos: 0 },
        },
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener alertas de contratos',
        data: {
          por_vencer: [],
          pendientes: [],
          vencidos: [],
          totales: { por_vencer: 0, pendientes: 0, vencidos: 0 },
        },
      };
    }
  },

  async actualizar(id, payload) {
    try {
      const response = await httpClient.put(`/contratos-empleado/${id}`, payload);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'Contrato actualizado exitosamente',
        advertencia_solapamiento: response.data.advertencia_solapamiento || null,
        contratos_solapados: response.data.contratos_solapados || [],
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al actualizar contrato',
        errors: error.response?.data?.errors,
      };
    }
  },

  async actualizarEstado(id, estado) {
    try {
      const response = await httpClient.put(`/contratos-empleado/${id}/estado`, { estado });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al actualizar estado del contrato',
      };
    }
  },

  async eliminar(id) {
    try {
      const response = await httpClient.delete(`/contratos-empleado/${id}`);
      return {
        success: true,
        message: response.data.message || 'Contrato eliminado',
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al eliminar el contrato',
      };
    }
  },
};

export default contratosEmpleadoService;
